const LocationMSBaseUrl = `https://prod-locationms.washout-app.com`;
const VehicleMSBaseUrl = `https://prod-vehiclems.washout-app.com`;
const WashingMSBaseUrl = `https://prod-washingms.washout-app.com`;
const UserMSBaseUrl = `https://prod-userms.washout-app.com`;

// Function to fetch cities with Recaptcha token
async function getCities() {
    const recaptchaToken = await getRecaptchaToken('/Location/Cities');
    return get(`${LocationMSBaseUrl}/Location/Cities`, recaptchaToken);
}

// Function to fetch vehicle brands with Recaptcha
async function getBrands() {
    const recaptchaToken = await getRecaptchaToken('/Vehicle/Brands');
    return get(`${VehicleMSBaseUrl}/Vehicle/Brands`, recaptchaToken);
}

// Function to fetch models by brand ID
async function getModelsByBrandId(brandId) {
    const recaptchaToken = await getRecaptchaToken(`/Vehicle/VehicleModels`);
    return get(`${VehicleMSBaseUrl}/Vehicle/${brandId}/VehicleModels`, recaptchaToken);
}

// Function to fetch available packages and services
async function getPackagesAndServices(vehicleModelId, countryId, cityId) {
    const recaptchaToken = await getRecaptchaToken(`/PackagePrice/Users/VehicleModel/PackagesAndServices`);
    return get(`${WashingMSBaseUrl}/PackagePrice/Users/VehicleModel/${vehicleModelId}/PackagesAndServices?countryId=${countryId}&cityId=${cityId}`, recaptchaToken);
}

// Function to fetch cities coverage
async function getCitiesCoverage() {
    const recaptchaToken = await getRecaptchaToken('/Location/Cities/ZonesBoundaries');
    return get(`${LocationMSBaseUrl}/Location/Cities/ZonesBoundaries`, recaptchaToken);
}

// Function to fetch zone information based on coordinates
async function getZoneByCoordinates(lat, lng) {
    const recaptchaToken = await getRecaptchaToken('/Location/ZoneSection');
    const url = `${LocationMSBaseUrl}/Location/ZoneSection?lat=${lat}&lng=${lng}`;
    return get(url, recaptchaToken);
}

// Helper function to validate email format
function isEmailValid(email) {
    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

async function formSupportSubmit(subject, message, fullName, email, phoneNumber, emailLanguageCode) {
    const recaptchaToken = await getRecaptchaToken('/Customer/Support');
    const url = `${UserMSBaseUrl}/Customer/Support`;

    const payload = {
        Subject: subject,
        Message: message,
        FullName: fullName,
        Email: email,
        PhoneNumber: phoneNumber,
        EmailLanguageCode: emailLanguageCode,
    };

    return post(url, payload, recaptchaToken);
}

async function sendJobEmailForAcademy(subject, workingCity, vehicleType, birthYear, address, drivingLicense, availability, message, firstname, lastname, email, phoneNumber, emailLanguageCode) {
    const recaptchaToken = await getRecaptchaToken('/Customer/AcademyJob');
    const url = `${UserMSBaseUrl}/Customer/AcademyJob`;

    const payload = {
        Subject: subject,
        WorkingCity: workingCity,
        VehicleType: vehicleType,
        BirthYear: birthYear,
        Address: address,
        DrivingLicense: drivingLicense,
        Availability: availability,
        Message: message,
        Firstname: firstname,
        Lastname: lastname,
        Email: email,
        PhoneNumber: phoneNumber,
        EmailLanguageCode: emailLanguageCode,
    };

    return post(url, payload, recaptchaToken);
}